import { chromeMetaTagClass } from './ChromeSurface'

type BaseTagProps = {
  angular: boolean
  children: string
  className?: string
}

export function ChromeMetaTag({ angular, children, className = '' }: BaseTagProps) {
  return (
    <span className={[chromeMetaTagClass(angular, 'outline'), className].filter(Boolean).join(' ')}>
      {children}
    </span>
  )
}

export function ChromeMonoTag({ angular, children, className = '' }: BaseTagProps) {
  return (
    <span className={[chromeMetaTagClass(angular, 'mono'), className].filter(Boolean).join(' ')}>
      {children}
    </span>
  )
}

export function ChromeStatusTag({
  angular,
  status,
}: {
  angular: boolean
  status: 'CANCELLED' | 'FAILED' | 'PENDING' | 'SUCCEEDED' | 'UNAVAILABLE'
}) {
  return (
    <span
      className={[
        chromeMetaTagClass(angular, 'outline'),
        /* 正文统一 text-ink，语义仅靠浅底 + 边框，避免暖色/云蓝主题下 pastel 字色糊在浅底上 */
        status === 'FAILED'
          ? 'border-[color-mix(in_srgb,var(--line)_58%,rgb(236_148_157)_42%)] bg-[color-mix(in_srgb,var(--panel)_90%,rgb(251_218_223)_10%)] text-ink'
          : status === 'CANCELLED'
            ? 'border-[color-mix(in_srgb,var(--line)_70%,var(--ink-soft)_30%)] bg-[color-mix(in_srgb,var(--panel)_92%,var(--ink-soft)_8%)] text-ink'
            : status === 'PENDING'
              ? 'border-[color-mix(in_srgb,var(--line)_62%,rgb(234_179_89)_38%)] bg-[color-mix(in_srgb,var(--panel)_90%,rgb(254_239_218)_10%)] text-ink'
              : status === 'UNAVAILABLE'
                ? 'border-[color-mix(in_srgb,var(--line)_75%,var(--ink-soft)_25%)] bg-[color-mix(in_srgb,var(--panel)_92%,var(--ink-soft)_8%)] text-ink'
                : 'border-[color-mix(in_srgb,var(--line)_52%,var(--accent)_48%)] bg-[color-mix(in_srgb,var(--panel)_90%,var(--accent)_10%)] text-ink',
      ].join(' ')}
    >
      {status === 'FAILED'
        ? '失败'
        : status === 'CANCELLED'
          ? '已取消'
          : status === 'PENDING'
            ? '进行中'
            : status === 'UNAVAILABLE'
              ? '无图'
              : '已完成'}
    </span>
  )
}
